document.addEventListener("DOMContentLoaded", function () {
  const applianceSelect = document.getElementById("appliance");
  const customWattageGroup = document.getElementById("custom-wattage-group");
  const calculateBtn = document.getElementById("calculate-btn");
  const resultsDiv = document.getElementById("results");

  // Show/hide custom wattage field
  applianceSelect.addEventListener("change", function () {
    if (this.value === "custom") {
      customWattageGroup.style.display = "block";
    } else {
      customWattageGroup.style.display = "none";
    }
  });

  // Calculate button click handler
  calculateBtn.addEventListener("click", function () {
    calculateCost();
  });

  // Also calculate when pressing Enter in input fields
  document.getElementById("usage").addEventListener("keypress", function (e) {
    if (e.key === "Enter") calculateCost();
  });

  document.getElementById("price").addEventListener("keypress", function (e) {
    if (e.key === "Enter") calculateCost();
  });

  document
    .getElementById("custom-wattage")
    .addEventListener("keypress", function (e) {
      if (e.key === "Enter") calculateCost();
    });

  function calculateCost() {
    // Get appliance wattage
    let wattage;
    if (applianceSelect.value === "custom") {
      wattage = parseFloat(document.getElementById("custom-wattage").value);
      if (isNaN(wattage) || wattage <= 0) {
        alert("Please enter a valid wattage");
        return;
      }
    } else {
      wattage = parseFloat(applianceSelect.value);
    }

    // Get usage
    const usageInput = parseFloat(document.getElementById("usage").value);
    if (isNaN(usageInput) || usageInput < 0) {
      alert("Please enter a valid usage value");
      return;
    }

    const usageUnit = document.getElementById("usage-unit").value;
    let usageHours;
    if (usageUnit === "minutes") {
      usageHours = usageInput / 60;
    } else {
      usageHours = usageInput;
    }

    // Get price
    const price = parseFloat(document.getElementById("price").value);
    if (isNaN(price) || price < 0) {
      alert("Please enter a valid electricity price");
      return;
    }

    // Calculate kWh per day
    const kWhPerDay = (wattage * usageHours) / 1000;

    // Calculate costs
    const costPerHour = (wattage / 1000) * price;
    const costPerDay = kWhPerDay * price;
    const costPerMonth = costPerDay * 30;
    const costPerYear = costPerDay * 365;

    // Display results
    document.getElementById("cost-hour").textContent =
      "$" + costPerHour.toFixed(2);
    document.getElementById("cost-day").textContent =
      "$" + costPerDay.toFixed(2);
    document.getElementById("cost-month").textContent =
      "$" + costPerMonth.toFixed(2);
    document.getElementById("cost-year").textContent =
      "$" + costPerYear.toFixed(2);
    document.getElementById("kwh-day").textContent = kWhPerDay.toFixed(2);

    // Show results with animation
    resultsDiv.style.display = "block";
  }
});
